import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-151ce2f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex justify-center" }
const _hoisted_2 = { class: "w-100" }
const _hoisted_3 = { class: "priority-wrapper" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label mb-2" }, "Prioridade:", -1))
const _hoisted_5 = { style: {"margin":"26px 0"} }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label mb-2" }, "Observação (opcional):", -1))
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "rel_title" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tooltip" }, [
  /*#__PURE__*/_createElementVNode("span", null, " Serviços que serão disparados em conjunto. Para desabilitar um serviço específico, clique em sua checkbox.")
], -1))
const _hoisted_10 = { class: "rel_services" }

import { ref, watch, withDefaults, onMounted } from 'vue';
import { MoleculeModal } from '@/components/molecules';

import { ActivityStore, Preloader, OperationStore, SelectStore } from '@/store';
import { ServiceCreate } from '@/core/model/Services';
import { create } from '@/core/service/ServiceService';
import { iconCreateSwalfire, iconErrorSwalfire } from '@/components/atoms/icons/iconsSwal';
import AtomSelectOutlined from '@/components/atoms/AtomSelectOutlined.vue';
import AtomInput from '@/components/atoms/AtomInput.vue';
import { showModal } from '@/utils/modal';
import { ModalTypes } from '@/core/enum/modal';
import Divider from 'primevue/divider';
import AtomCheckBoxButton from '@/components/atoms/AtomCheckBoxButton.vue';
import { OptionSelectActivity } from '@/core/model';
import { useRouter } from 'vue-router';

interface IProps {
  showModal: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ModalSolicitation',
  props: {
    showModal: { type: Boolean, default: false }
  },
  emits: ['hiddenModal'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const getDescription = (description) => {
  return `<b style="color: #292E36; font-size: 16px; font-weight: 600;">Descrição:</b><br>${description}`;
}

const computedStyles = getComputedStyle(document.documentElement);
const primaryColor = computedStyles.getPropertyValue('--components-main100');
const confirmButtonColor = computedStyles.getPropertyValue('--components-main100');
const cancelButtonColor = computedStyles.getPropertyValue('--primary-c10');
const nextActivities = ref<OptionSelectActivity[]>([])


onMounted(async () => {
  await SelectStore.actions.GetAllDepartment();
  await SelectStore.actions.GetAllLocation();

  SelectStore.state.listCategoriesSelect = []
  SelectStore.state.listActivitiesSelect = []
});


const fetchCategoriesByDepartment = async () => {
  if (data.value.departamentId) {
    Preloader.actions.ActionSetPreloader(true);
    await SelectStore.actions.GetAllCategories(data.value.departamentId);
    data.value.categoryId = "";
    data.value.activityId = "";
    Preloader.actions.ActionSetPreloader(false);
  } else {
    SelectStore.state.listCategoriesSelect = [];
    data.value.categoryId = "";
    data.value.activityId = "";
  }
};

const fetchActivitiesByCategory = async () => {
  if (data.value.categoryId) {
    Preloader.actions.ActionSetPreloader(true);
    await SelectStore.actions.GetAllActivity("", data.value.categoryId);
    data.value.activityId = ""
    Preloader.actions.ActionSetPreloader(false);
  } else {
    SelectStore.state.listActivitiesSelect = []
    data.value.activityId = ""
  }
};

const fetchNextActivitiesByCategory = async () => {
  if (data.value.activityId) {
    Preloader.actions.ActionSetPreloader(true);
    await ActivityStore.actions.GetNextActivitiesByActivityId(data.value.activityId);
    nextActivities.value = ActivityStore.state.listNextActivitiesSelect;
    Preloader.actions.ActionSetPreloader(false);
  } else {
    ActivityStore.state.listNextActivitiesSelect = []
    data.value.nextActivities = ""
  }
};

const fetchUsersByRoom = async () => {
  if (data.value.location) {
    Preloader.actions.ActionSetPreloader(true);
    const location = SelectStore.state.listLocationsSelect.find((value) => value.value === data.value.location)
    await OperationStore.actions.GetUsersByRoom(location?.text ?? "");
    Preloader.actions.ActionSetPreloader(false);
  } else {
    data.value.client = ""
  }
};

const defaultValues = {
  activityId: '',
  location: '',
  categoryId: '',
  departamentId: '',
  client: '',
  description: '',
  priority: "1",
};
const data = ref<ServiceCreate>({ ...defaultValues });
const defaultValuesErr = {
  activityId: false,
  client: false,
  location: false,
  departamentId: false,
  categoryId: false,
};
const errors = ref({ ...defaultValuesErr });

const route = useRouter();

const show = ref<boolean>(props.showModal);
const emit = __emit;

function handleHiddenModal() {
  clear();
  emit('hiddenModal');
}

async function handleAdd() {
  try {
    Preloader.actions.ActionSetPreloader(true);
    if (validate()) {
      try {
        const user = OperationStore.state.listUsersOperationsSelect.find((value) => value.value === data.value.client)
        await create({
          priority: Number(data.value.priority),
          activityId: data.value.activityId,
          quantity: data.value.quantity || 0,
          operationId: 1,
          location: data.value.location,
          client: user ? {
            name: user.text,
            doc: user.value
          } : undefined,
          description: data.value.description,
          triggerActivities: nextActivities.value.map((value) => value.value)
        });
        await showModal({
          modal_type: ModalTypes.SUCESS_MODAL,
          modalTitle: "Serviço ",
          type_message: `cadastrado com sucesso!`,
          iconHtml: iconCreateSwalfire(primaryColor.trim(), '#FFFFFF'),
          confirmButtonText: 'Finalizar',
          confirmButtonColor: confirmButtonColor.trim(),
          customClass: {
            confirmButton: 'swalfire-confirm-button',
          },
        })
      } catch (error: any) {
        if (error.response && error.response.status == 409) {
          await showModal({
            modal_type: ModalTypes.CONFIRME_MODAL,
            modalTitle: `Já existe esse serviço em andamento para o hospede  ${data.value.client}. `,
            type_message: "Deseja criar novamente?",
            iconHtml: iconCreateSwalfire(primaryColor.trim(), '#FFFFFF'),
            buttonsStyling: true,
            confirmButtonColor: confirmButtonColor.trim(),
            cancelButtonColor: cancelButtonColor.trim(),
          }).then(async ({ isConfirmed }) => {
            if (isConfirmed) {
              const user = OperationStore.state.listUsersOperationsSelect.find((u) => u.text = data.value.client)
              await create({
                activityId: data.value.activityId,
                quantity: data.value.quantity || 0,
                operationId: 1,
                priority: Number(data.value.priority),
                location: data.value.location,
                client: { name: user?.text, doc: user?.value },
                description: data.value.description,
                triggerActivities: nextActivities.value.map((value) => value.value),
              });
              await showModal({
                modal_type: ModalTypes.SUCESS_MODAL,
                modalTitle: "Serviço ",
                type_message: `cadastrado com sucesso!`,
                iconHtml: iconCreateSwalfire(primaryColor.trim(), '#FFFFFF'),
                confirmButtonText: 'Finalizar',
                confirmButtonColor: confirmButtonColor.trim(),
                customClass: {
                  confirmButton: 'swalfire-confirm-button',
                },
              });
            }
          });
        } else {
          showModal({
            modal_type: ModalTypes.ERROR_MODAL,
            modalTitle: "Erro",
            type_message: "Erro interno de servidor.",
            iconHtml: iconErrorSwalfire(primaryColor.trim(), '#FFFFFF'),
            confirmButtonColor: confirmButtonColor.trim(),
          });
        }
      }
    } else {
      return;
    }
    clear();
    handleHiddenModal();
    route.go(0);
  } finally {
    Preloader.actions.ActionSetPreloader(false);
  }
}

function handleNextActivities(status: boolean, id: string) {
  if (status) {
    nextActivities.value?.push(ActivityStore.state.listNextActivitiesSelect.find((value) => value.value === id)!)
  } else {
    nextActivities.value = nextActivities.value?.filter((value) => value.value != id);
  }
}

function validate() {
  if (!data.value.activityId) errors.value.activityId = true;
  else errors.value.activityId = false;

  if (!data.value.location) errors.value.location = true;
  else errors.value.location = false;

  if (!data.value.categoryId) errors.value.categoryId = true;
  else errors.value.categoryId = false;

  if (!data.value.departamentId) errors.value.departamentId = true;
  else errors.value.departamentId = false;

  return (
    !errors.value.activityId &&
    !errors.value.location &&
    !errors.value.categoryId &&
    !errors.value.departamentId
  );
}

function clear() {
  data.value = { ...defaultValues };
  errors.value = { ...defaultValuesErr };
}

watch(
  () => data.value.departamentId,
  async (newValue, oldValue) => {
    if (newValue !== oldValue) {
      SelectStore.state.listCategoriesSelect = []
      await fetchCategoriesByDepartment();
    }
  }
);

watch(
  () => data.value.categoryId,
  async (newValue, oldValue) => {
    if (newValue !== oldValue) {
      ActivityStore.state.listActivitiesSelect = []
      await fetchActivitiesByCategory();
    }
  }
);

watch(
  () => data.value.activityId,
  async (newValue, oldValue) => {
    if (newValue !== oldValue) {
      ActivityStore.state.listNextActivitiesSelect = []
      await fetchNextActivitiesByCategory();
    }
  }
);

watch(
  () => [data.value.location], async (newValue, oldValue) => {
    if (newValue !== oldValue) {
      data.value.client = '';
      await fetchUsersByRoom()
    }
  }
);

watch(
  () => props.showModal,
  () => {
    show.value = props.showModal;
  }
);

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_btn_toggle = _resolveComponent("v-btn-toggle")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!

  return (_openBlock(), _createBlock(_unref(MoleculeModal), {
    onHasBtnClose: handleHiddenModal,
    onHandleConfirm: handleAdd,
    onHandleCancel: handleHiddenModal,
    title: "Solicitar serviço",
    "show-header": true,
    show: show.value,
    isService: true
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_v_row, { "align-content": "space-between" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(AtomSelectOutlined, {
                    width: "100%",
                    placeholder: "Clique para selecionar",
                    height: "46px",
                    label: "Departamento",
                    "icon-color": _unref(primaryColor),
                    "custom-no-data-text": 'Selecione um departamento',
                    "prepend-icon": "mdi-domain",
                    options: _unref(SelectStore).state.listDepartmentsSelect,
                    "enable-load": false,
                    modelValue: data.value.departamentId,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((data.value.departamentId) = $event)),
                    "has-error": errors.value.departamentId,
                    "msg-error": "Selecione um departamento válido"
                  }, null, 8, ["icon-color", "options", "modelValue", "has-error"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(AtomSelectOutlined, {
                    width: "100%",
                    placeholder: "Clique para selecionar",
                    "icon-color": _unref(primaryColor),
                    "custom-no-data-text": 'Selecione uma categoria',
                    height: "46px",
                    "prepend-icon": "mdi-domain",
                    label: "Categoria",
                    options: _unref(SelectStore).state.listCategoriesSelect,
                    "enable-load": false,
                    modelValue: data.value.categoryId,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((data.value.categoryId) = $event)),
                    "has-error": errors.value.categoryId,
                    "msg-error": "Selecione uma categoria válida",
                    class: "teste"
                  }, null, 8, ["icon-color", "options", "modelValue", "has-error"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, { "align-content": "space-between" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(AtomSelectOutlined, {
                    width: "100%",
                    placeholder: "Clique para selecionar",
                    label: "Serviços",
                    "icon-color": _unref(primaryColor),
                    "custom-no-data-text": 'Selecione um serviço',
                    height: "46px",
                    "prepend-icon": "mdi-domain",
                    options: _unref(SelectStore).state.listActivitiesSelect,
                    "enable-load": false,
                    modelValue: data.value.activityId,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((data.value.activityId) = $event)),
                    "has-error": errors.value.activityId,
                    "msg-error": "Selecione um serviço válido"
                  }, null, 8, ["icon-color", "options", "modelValue", "has-error"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(AtomInput, {
                    type: "number",
                    label: "Quantidade",
                    placeholder: "Digite a quantidade",
                    "font-weight": "500",
                    modelValue: data.value.quantity,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((data.value.quantity) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, { "align-content": "space-between" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(AtomSelectOutlined, {
                    width: "100%",
                    placeholder: "Clique para selecionar",
                    "icon-color": _unref(primaryColor),
                    "custom-no-data-text": 'Selecione uma localização',
                    label: "Localizações",
                    height: "46px",
                    "prepend-icon": "mdi-domain",
                    options: _unref(SelectStore).state.listLocationsSelect,
                    "enable-load": false,
                    modelValue: data.value.location,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((data.value.location) = $event)),
                    "has-error": errors.value.activityId,
                    "msg-error": "Selecione uma localização válido"
                  }, null, 8, ["icon-color", "options", "modelValue", "has-error"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(AtomSelectOutlined, {
                    width: "100%",
                    placeholder: "Clique para selecionar",
                    label: "Cliente (opcional)",
                    "icon-color": _unref(primaryColor),
                    "custom-no-data-text": 'Selecione um cliente',
                    height: "46px",
                    "prepend-icon": "mdi-domain",
                    options: _unref(OperationStore).state.listUsersOperationsSelect,
                    "enable-load": false,
                    modelValue: data.value.client,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((data.value.client) = $event)),
                    "has-error": errors.value.client,
                    "msg-error": "Selecione um cliente válido"
                  }, null, 8, ["icon-color", "options", "modelValue", "has-error"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            class: "priority",
            "align-content": "space-between"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createVNode(_component_v_btn_toggle, {
                  modelValue: data.value.priority,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((data.value.priority) = $event)),
                  class: "priority-toggle"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, { value: "1" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Baixa")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_btn, { value: "2" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Média")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_btn, { value: "3" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Alta")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _withDirectives(_createElementVNode("textarea", {
              class: "card-observation text-sm",
              rows: "3",
              cols: "130",
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((data.value.description) = $event)),
              style: {"width":"100%"},
              placeholder: "Digite suas observações aqui..."
            }, null, 512), [
              [_vModelText, data.value.description]
            ])
          ]),
          (nextActivities.value.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("label", _hoisted_8, [
                  _createTextVNode("Serviços Relacionados "),
                  _createVNode(_component_v_tooltip, {
                    text: "",
                    location: "top"
                  }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_icon, _mergeProps(props, {
                        style: {"padding-left":"1rem"},
                        color: "#FF5C00"
                      }), {
                        default: _withCtx(() => [
                          _createTextVNode("mdi-information")
                        ]),
                        _: 2
                      }, 1040)
                    ]),
                    default: _withCtx(() => [
                      _hoisted_9
                    ]),
                    _: 1
                  })
                ]),
                _createVNode(_unref(Divider)),
                _createElementVNode("div", _hoisted_10, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ActivityStore).state.listNextActivitiesSelect, (item, index) => {
                    return (_openBlock(), _createBlock(AtomCheckBoxButton, {
                      key: index,
                      "tooltip-label": getDescription(item.description),
                      "tooltip-position": "top",
                      label: item.text,
                      onCheck: (value) => handleNextActivities(value, item.value)
                    }, null, 8, ["tooltip-label", "label", "onCheck"]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})